// extracted by mini-css-extract-plugin
export default {"variantModal":"VariantModal_variantModal__1bcAc","form":"VariantModal_form__0eMKM"};